import cheerio from "cheerio";
import axios from "axios";

const validUrl = require("valid-url");

const addhttp = (url) => {
  let retUrl = url;
  if (!/^(f|ht)tps?:\/\//i.test(url)) {
    retUrl = `https://${url}`;
  }
  return retUrl;
};

const walkDOM = (root, arr, count) => {
  if (
    root.data &&
    root.data.length > 5 &&
    /\S/.test(root.data) &&
    root.data.substring(0, 4) === "<div" &&
    root.data
      .substring(0, 21)
      .toLowerCase()
      .indexOf("nar-root") >= 0
  ) {
    const dataPostID = root.data.split(" ")[2];
    const id = dataPostID
      .split("=")[1]
      .replace("′", "")
      .replace("’", "")
      .replace("'", "")
      .replace("'", "")
      .replace("’", "");
    arr.push(id);

    return;
  }

  if (!root.children || arr.length === 1) {
    return;
  }

  if (root && root.children) {
    for (let i = 0; i < root.children.length; i += 1) {
      const children = root.children;
      walkDOM(children[i], arr, count + 1);
    }
  }
};

const FindBlogExists = (url) => {
  return new Promise((resolve, reject) => {
    let tempUrl = url;

    if (tempUrl.includes("com") && !tempUrl.includes("https")) {
      tempUrl = addhttp(tempUrl);
    }

    if (!validUrl.isUri(tempUrl)) {
      reject("Invalid URL");
    }

    const corsURL = `${process.env.CORS_PROXY_URL}${tempUrl}`;

    console.log(corsURL);

    axios
      .get(corsURL)
      .then((res) => {
        const { data } = res;
        const $ = cheerio.load(data);

        const newPost = $(".nar-root");
        let oldNarr;

        // In the case where there is a code tag
        const codeTag = $("code");
        if (codeTag && codeTag.length > 0 && codeTag["0"].children) {
          codeTag.each((_, ele) => {
            if (ele.children["0"].data) {
              const htmlString = ele.children["0"].data;
              const parsedHTML = cheerio.load(htmlString);
              const postID = parsedHTML(".nar-root").attr("data-post-id");
              if (postID) {
                resolve(postID);
              }
            }
          });
        }

        // In the case where there is only a narrative image instead of the blog

        const imageTag = $("img");
        if (imageTag && imageTag.length > 0 && newPost.length === 0) {
          imageTag.each((_, ele) => {
            if (ele.attribs.src) {
              const imageURL = ele.attribs.src;
              if (
                imageURL.substring(0, 37) ===
                "https://content1.getnarrativeapp.com/"
              ) {
                const postID = imageURL.split("/")[4];
                resolve(postID);
              }
            }
          });
        }

        // In the case where the code is encapsulated inside of a p tag
        const root = $("body");
        console.log(root);
        const idArr = [];
        walkDOM(root["0"], idArr, 0);
        if (idArr.length === 1) {
          resolve(idArr[0]);
        }

        if (newPost.length > 0) {
          const postID = $(".nar-root").attr("data-post-id");
          if (!postID) {
            reject("Post ID Not Found");
          }
          resolve(postID);
        }

        if (newPost.length === 0) {
          // Check for old post if new post doesn't exist
          $("div").each((i, elem) => {
            if (elem.attribs) {
              if (elem.attribs.id) {
                if (elem.attribs.id.match("nar_root_.*")) {
                  // Checking regex to match nar_root
                  oldNarr = elem.attribs.id.split("_");
                  const id = oldNarr[2]; // Get the ID
                  resolve(id);
                }
              }
            }
          });

          // Old post not found so reject
          reject("Post not found on the page");
        }
      })
      .catch((err) => reject(err.response.status));
  });
};

export default FindBlogExists;
